import { useDesignContext } from '@systemeio/digital-store-shared'
import { ColorPicker } from '@systemeio/ui'
import React from 'react'
import { FieldLabel } from 'shared/components/form/field-label'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export function StoreThemeColorPicker() {
  const { t } = useLocoTranslation()
  const { state, setState } = useDesignContext()

  return (
    <div className={'flex flex-col gap-1'}>
      <FieldLabel label={t('dashboard.store.theme.colors')} />
      <div className={'flex gap-3'}>
        <ColorPicker
          popoverClassName="z-50"
          color={state.primaryColor}
          onChange={primaryColor => setState(prev => ({ ...prev, primaryColor }))}
        />
        <ColorPicker
          popoverClassName="z-50"
          color={state.secondaryColor}
          onChange={secondaryColor => setState(prev => ({ ...prev, secondaryColor }))}
        />
        <ColorPicker
          popoverClassName="z-50"
          color={state.tertiaryColor}
          onChange={tertiaryColor => setState(prev => ({ ...prev, tertiaryColor }))}
        />
      </div>
    </div>
  )
}
